module.exports = __webpack_public_path__ + "img/downloadPlayMarketHoozieReward.91ae76b5.svg";